export const TERRITORY_DELETE_RESET = 'TERRITORY_DELETE_RESET'
export const TERRITORY_DELETE_SET_ERROR = 'TERRITORY_DELETE_SET_ERROR'
export const TERRITORY_DELETE_SET_DELETED = 'TERRITORY_DELETE_SET_DELETED'
export const TERRITORY_DELETE_TOGGLE_LOADING = 'TERRITORY_DELETE_TOGGLE_LOADING'
